module.exports = __webpack_public_path__ + "media/images/medicine-card-9069e9981dff164e8650eccb5a04931d.svg";